<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid text-center" style="background-color: white;">
            <br/>
            <div class="col-sm-10 col-xs-12 text-center">
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ชื่อ
                    </label>
                    <div class="col-sm-6">
                        <input type="text"
                               placeholder="ชื่อที่จะใช้แสดง"
                               class="form-control"
                               v-model="form.name"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ชื่อผู้ใช้งาน(รหัสพนักงาน)
                    </label>
                    <div class="col-sm-6">
                        <input type="text"
                               placeholder="username"
                               class="form-control"
                               v-model="form.username"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        แผนก
                    </label>
                    <div class="col-sm-6">
                        <select class="form-control mr-sm-2"
                                v-model="form.role">
                            <option value="">เลือกแผนก</option>
                            <template v-for="(x,i) in option_role">
                                <option v-if="i == 8" value="8">เปิดบิล</option>
                                <option v-else-if="i == 12" value="12">คนขับรถ</option>
                                <!--                                <option v-else :value="i">{{x}}(ยังใช้ไม่ได้)</option>-->
                            </template>
                        </select>
                    </div>
                </div>
                <div class="form-group row" v-if="form.role == 12 && !this.showing">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        คนขับรถ
                    </label>
                    <div class="col-sm-6">
                        <multiselect
                            :options="optionDriver"
                            label="name"
                            placeholder="กรุณาเลือกคนขับ"
                            v-model="form.driver"
                            :show-labels="false"
                            track-by="name">
                        </multiselect>
                    </div>
                </div>
                <div class="form-group row" v-if="this.showing">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        รหัสผ่าน
                    </label>
                    <div class="col-sm-6">
                        <input type="text"
                               placeholder="password"
                               class="form-control"
                               v-model="form.password"/>
                    </div>
                </div>
                <b-form inline>
                    <label class="col-4"/>
                    <div class="col-sm-6 form-button" style="padding-left: 30px;">
                        <b-button :disabled="this.showing"
                                  v-if="!this.id"
                                  variant="success"
                                  @click="saveUserForm">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </b-button>
                        <b-button v-else
                                  variant="success"
                                  @click="updatePassword(form.username)">
                            <icon name="save" style="width: 25px"></icon>
                            อัพเดทรหัสผ่าน
                        </b-button>
                        &nbsp;&nbsp;
                        <b-button class="btn btn-secondary"
                                  @click="goUserList">
                            <icon name="times" style="width: 25px"></icon>
                            ย้อนกลับ
                        </b-button>
                    </div>
                </b-form>
                <br/>
            </div>
        </div>
        <!--<pre class="alert alert-primary">{{ form.product_type }}</pre>-->
        <!--<pre class="alert alert-success">{{ form }}</pre>-->
    </div>
</template>

<script>
import HeaderTitle from "../../HeaderTitle";
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import {canViewSuperAdmin,} from "../../../util/Permissions";

export default {
    components: {HeaderTitle, Multiselect},
    name: "products-information",
    props: {
        id: {default: null}
    },
    data() {
        return {
            items: [
                {
                    text: "จัดการผู้ใช้",
                    to: {name: "user-management-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            form: {
                name: '',
                username: '',
                role: '',
                password: '',
                repassword: '',
                driver: ''
            },
            showing: false,
            option_role: {
                '2': 'production-lead',
                '3': 'sheet-lead',
                '4': 'forming-lead',
                '5': 'foam-lead',
                '6': 'sale',
                '7': 'purchases-manager',
                '8': 'lead-senior',
                '9': 'sale-order',
                '10': 'sale-driver',
                '11': 'hr',
                '12': 'driver'
            }
        };
    },
    created() {
        this.$store.dispatch('Driver/getAll')
        //console.log(this.id)
        if (this.id) {
            this.getDetail(this.id);
        }
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionDriver: state => {
                return state.Driver.optionDriver.filter(driver => !driver.cancel_status && driver.user_id == null);
            },
        })
    },
    methods: {
        saveUserForm() {
            if (this.form.role == '') {
                alert('กรุณาเลือกแผนก')
            } else if (this.form.name == '') {
                alert('กรุณาใส่ชื่อ')
            } else if (this.form.username == '') {
                alert('กรุณาใส่ชื่อผู้ใช้งาน')
            } else if (!this.form.driver && this.form.role == 12) {
                alert('กรุณาเลือกคนขับรถ')
            } else {
                this.$store.dispatch('Users/register', this.form).then(res => {
                    if (res.msg) {
                        alert(res.msg)
                    } else {
                        this.showing = true;
                        this.form = res;
                        alert('สร้างสำเร็จ')
                    }
                })
            }
        },
        goUserList() {
            this.$router.push('user-management')
        },
        updatePassword(id) {
            this.$store.dispatch('Users/update', {id: id, password: this.form.password}).then(res => {
                this.form = res;
                alert('เปลี่ยนรหัสผ่านสำเร็จ')
            })
        },
        getDetail(id) {
            this.$store.dispatch('Users/show', id).then(res => {
                this.showing = true;
                this.form = res;
            })
        }
    }
};
</script>

<style scoped>
.form-button {
    /*margin-left: 20%;*/
    display: flex;
    padding: 0;
}
</style>
